import { useDeviceDetectionStore } from '@/stores/device_detection.js';

export default {
  install(app) {
    const deviceStore = useDeviceDetectionStore();

    // Propiedades globales para acceso directo
    app.config.globalProperties.$device = {
      get isMobile() {
        return deviceStore.isMobile;
      },
      get isTablet() {
        return deviceStore.isTablet;
      },
      get isDesktop() {
        return deviceStore.isDesktop;
      },
      get deviceType() {
        return deviceStore.deviceType;
      },
      get isPortrait() {
        return deviceStore.isPortrait;
      },
      get isLandscape() {
        return deviceStore.isLandscape;
      },
      get touchSupport() {
        return deviceStore.touchSupport;
      },
      get screenWidth() {
        return deviceStore.screenWidth;
      },
      get screenHeight() {
        return deviceStore.screenHeight;
      },
      get info() {
        return deviceStore.getDeviceInfo;
      },

      // Métodos de utilidad
      shouldShowMobileView() {
        return deviceStore.isMobile || (deviceStore.isTablet && deviceStore.isPortrait);
      },

      isScreenSize(breakpoint) {
        const breakpoints = {
          xs: 480,
          sm: 768,
          md: 1024,
          lg: 1280,
          xl: 1920,
        };
        return deviceStore.screenWidth <= breakpoints[breakpoint];
      },
    };

    // Provide para composition API
    app.provide('device', app.config.globalProperties.$device);
  },
};
